<template>
  <slider v-if="length > 0" :items="items" :config="config">
    <template v-slot:head>
      <slot name="head"></slot>
    </template>
    <template v-slot:body="{ item, index }">
      <slot name="body" :item="item" :index="index" />
    </template>
    <template v-slot:navigation>
      <slot name="navigation" v-if="length > 1" />
    </template>
  </slider>
</template>
<script>
import Slider from '../Slider';
import { AjaxCaller } from '@ssdcode/cms-partials';

export default {
  name: 'FeedWrapper',
  mixins: [AjaxCaller],
  components: { Slider },
  props: {
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      items: [],
      length: 0,
    };
  },
  created() {
    this.makeAjaxCall(this.success, this.failure);
  },
  methods: {
    success(response) {
      this.stopProcessingAjaxCall();
      if (!response.data.records) {
        return;
      }
      this.items = response.data.records;
      this.length = this.items.length;
    },
    failure(error) {
      this.stopProcessingAjaxCall();
      console.log(error);
    },
  },
};
</script>
